export const setupSw = () => {
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.controller === null) {
      if (ENV === 'release' || MODE === 'PRIVATIZATION') {
        navigator.serviceWorker
          .register('/sw.js', {
            scope: './',
          })
          .then((registration) => {
            registration.addEventListener('activate', () => {
              caches
                .keys()
                .then((cacheNames) =>
                  Promise.all(
                    cacheNames
                      .filter((cacheName) => cacheName.startsWith('idp'))
                      .map((cacheName) => caches.delete(cacheName)),
                  ),
                );
            });
          })
          .catch((error) => {
            console.error('Service worker registration failed:', error);
          });
      }
    } else {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          registrations.forEach((registration) => registration.unregister()),
        )
        .catch((error) =>
          console.error('Service worker unregistration failed:', error),
        );
    }
  }
};
